export default {
  update (el, binding, vnode) {
    const element = vnode.elm

    if (element.value.length > 0) {
      element.classList.add('not-empty')
    } else {
      element.classList.remove('not-empty')
    }
  }
}
